import { Printer, Target, Lightbulb } from "lucide-react";
import { StoryShareButton } from "./StoryShareButton";

export const PlanOverview = ({ plan }) => {
  const { result: r, request: q } = plan;
  return (
    <section data-testid="plan-overview" className="px-6 md:px-12 pt-6 pb-10">
      <p className="text-xs uppercase tracking-[0.3em] text-[var(--muted)] mb-4">
        {q.business_name} · {q.niche} · {q.platform}
      </p>
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
        <h1 data-testid="plan-headline" className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight max-w-4xl leading-[1.03]">
          {r.headline}
        </h1>
        <div className="no-print flex flex-wrap gap-3 self-start">
          <StoryShareButton plan={plan} />
          <button onClick={() => window.print()} data-testid="print-plan-btn"
            className="rounded-full border border-[var(--green)] px-5 py-2.5 font-semibold flex items-center gap-2 hover:bg-[var(--green)] hover:text-[var(--cream)] transition-colors">
            <Printer size={16} /> Print / Save PDF
          </button>
        </div>
      </div>
      <p className="mt-6 text-base md:text-lg text-[var(--muted)] max-w-3xl">{r.summary}</p>
      <div className="grid md:grid-cols-12 gap-4 mt-10">
        <div className="md:col-span-5 bg-[var(--gold)] rounded-3xl p-6 -rotate-1">
          <p className="font-semibold flex items-center gap-2 mb-2"><Target size={18} /> Beat {q.competitor}</p>
          <p data-testid="competitor-insight">{r.competitor_insight}</p>
        </div>
        <div className="md:col-span-7 grid sm:grid-cols-2 gap-3">
          {(r.pillars || []).map((p, i) => (
            <div key={p.name} data-testid={`pillar-${i}`} className="bg-white border border-[var(--line)] rounded-2xl p-4">
              <p className="font-bold">{p.name}</p>
              <p className="text-sm text-[var(--muted)]">{p.why}</p>
            </div>
          ))}
        </div>
      </div>
      {r.tips?.length > 0 && (
        <div className="mt-6 flex flex-wrap gap-3">
          {r.tips.map((t) => (
            <span key={t} className="text-sm bg-[var(--green)] text-[var(--cream)] rounded-full px-4 py-2 flex items-center gap-2">
              <Lightbulb size={14} className="text-[var(--gold)]" /> {t}
            </span>
          ))}
        </div>
      )}
    </section>
  );
};
